var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card" }, [
    _c(
      "header",
      { staticClass: "modal-card-head" },
      [
        _c("b-icon", {
          staticClass: "mr-1",
          attrs: {
            icon: _vm.department.disableStatus.isDisabled
              ? "check-circle"
              : "ban",
            size: "is-medium",
          },
        }),
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.department.disableStatus.isDisabled
                  ? _vm.$t(
                      "admin.component.company.detail.enable_department.title"
                    )
                  : _vm.$t(
                      "admin.component.company.detail.disable_department.title"
                    )
              ) +
              " "
          ),
        ]),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "modal-card-body" },
      [
        _c("p", [
          _vm._v(
            " " +
              _vm._s(
                _vm.department.disableStatus.isDisabled
                  ? _vm.$t(
                      "admin.component.company.detail.enable_department.message"
                    )
                  : _vm.$t(
                      "admin.component.company.detail.disable_department.message"
                    )
              ) +
              " "
          ),
        ]),
        _c("br"),
        !_vm.department.disableStatus.isDisabled
          ? _c(
              "b-field",
              {
                attrs: {
                  label: _vm.$t(
                    "admin.component.company.detail.disable_department.reason"
                  ),
                  type: {
                    "is-danger": _vm.errors.has(
                      _vm.$t(
                        "admin.component.company.detail.disable_department.reason"
                      )
                    ),
                  },
                  message: _vm.errors.first(
                    _vm.$t(
                      "admin.component.company.detail.disable_department.reason"
                    )
                  ),
                },
              },
              [
                _c("b-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "max:255",
                      expression: "'max:255'",
                    },
                  ],
                  attrs: {
                    type: "textarea",
                    name: _vm.$t(
                      "admin.component.company.detail.disable_department.reason"
                    ),
                    expanded: "",
                    maxlength: "255",
                  },
                  model: {
                    value: _vm.reasonText,
                    callback: function ($$v) {
                      _vm.reasonText = $$v
                    },
                    expression: "reasonText",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "footer",
      {
        staticClass: "modal-card-foot",
        staticStyle: { "justify-content": "space-between" },
      },
      [
        _c(
          "b-button",
          {
            on: {
              click: function ($event) {
                return _vm.resultRetrieved(false)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("generals.close")))]
        ),
        _c(
          "b-button",
          {
            attrs: { type: "is-primary" },
            on: {
              click: function ($event) {
                return _vm.manageDepartmentAccessibility()
              },
            },
          },
          [
            _vm._v(
              _vm._s(
                _vm.department.disableStatus.isDisabled
                  ? _vm.$t(
                      "admin.component.company.detail.enable_department.confirm"
                    )
                  : _vm.$t(
                      "admin.component.company.detail.disable_department.confirm"
                    )
              )
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }